import React from 'react'
import styled from 'styled-components'
import { TransactionalCreditEvaluation } from '../../../services/bff/transactional-credit/dtos/transactional-credit-evaluation.dto'
import { black, blue, gray, green, white } from '../../../ui/utils/_colors'
import { calculateMaxAmountPlusDownPayment, calculateMaxDownPayment, findProductWithPriceRange, simplifyProducts } from './ProductsHelper'
import { ProductsSession } from './ProductsSession'
import { formatBRL } from '../../../cash-register/common/formatBRL'

interface Props {
  evaluationResult: TransactionalCreditEvaluation
  handleGoToApplication?: () => void
}

export const SmartphoneSaleApproved: React.FC<Props> = (props: Props) => {
  const { evaluationResult, handleGoToApplication } = props

  const products = simplifyProducts(evaluationResult?.products)
  const productWithPriceRange = findProductWithPriceRange(products)

  const maxAmountPlusDownPayment = productWithPriceRange ? calculateMaxAmountPlusDownPayment(productWithPriceRange.maxDownPaymentRate, evaluationResult.policy!!.maxAmount) : 0
  const maxDownPayment = calculateMaxDownPayment(maxAmountPlusDownPayment, evaluationResult.policy!!.maxAmount)

  return (
    <MainContainer>
      {productWithPriceRange && (
        <PreApprovedSection>
          <PreApprovedTitle>Cliente pré-aprovado</PreApprovedTitle>
          <PreApprovedInfo>
            <PreApprovedLabel>Cliente pode comprar aparelhos de até</PreApprovedLabel>
            <PreApprovedValue>{formatBRL(maxAmountPlusDownPayment)}</PreApprovedValue>
          </PreApprovedInfo>
          <DownPaymentTag>Entrada fixa de até {formatBRL(maxDownPayment)}</DownPaymentTag>
        </PreApprovedSection>
      )}
      <ProductsSession
        products={products}
        canSelectItems={false}
        layout={'single-column'}
      ></ProductsSession>
      <Footer>
        <ConfirmButton onClick={handleGoToApplication} backgroundColor={white.primary} textColor={green.dark1}>
          Cadastrar cliente
        </ConfirmButton>
      </Footer>
    </MainContainer>
  )
}

const MainContainer = styled.div`
  padding: 24px;

  display: flex;
  flex-direction: column;
  text-align: left;
  height: calc(100% - 56px);

  @media (max-width: 460px) {
    margin: 0px 8px 0px 8px;
    padding: 10px 8px 20px 8px;
  }
  justify-content: space-between;

  max-width: 460px;
  margin: auto;
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2vh;
`
const ConfirmButton = styled.button`
  margin-top: 1vh;
  background: ${(props: any) => (props && props.disabled ? green.light3 : green.dark1)};
  border-radius: 10px;
  border: 0px;
  padding: 12px;
  height: 48px;
  width: 100%;
  max-width: 328px;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: ${white.primary};
`

const PreApprovedSection = styled.div`
  margin-bottom: 32px;
`

const PreApprovedTitle = styled.h1`
  font-family: Inter;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: ${black.text};
  margin-bottom: 24px;
`

const PreApprovedInfo = styled.div`
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 24px;
  }
`

const PreApprovedLabel = styled.p`
  font-family: Inter;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: ${gray.scale700};
  margin-bottom: 8px;
`

const PreApprovedValue = styled.p`
  font-family: Inter;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  color: #19191C;
  margin: 0;
`

const DownPaymentTag = styled.div`
  display: inline-block;
  padding: 4px 12px;
  background: #E5EDFF;
  border-radius: 100px;
  border: 1px solid ${blue.yonder};
  color: ${blue.yonder};
  font-family: Inter;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
` 